var render = function render(){var _vm=this,_c=_vm._self._c;return _c('information-panel',{attrs:{"title":"项目信息","loading":_vm.loading,"columns":_vm.columns,"data-source":_vm.projectInfo,"card-bordered":_vm.cardBordered}})
}
var staticRenderFns = []

export { render, staticRenderFns }